<template>
  <div class="tpf-mf-layout--content">
    <div class="content--header">
      <el-row>
        <el-col :span="20">
          <el-form ref="dataForm" :model="formData" :rules="rules" label-position="right" label-width="100px">
            <el-form-item label="巡检单名称" prop="templateName">
              <el-input v-model="formData.templateName" maxlength="15" style="width:350px" show-word-limit />
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="4" class="text-right">
          <el-button plain class="filter-item" type="primary" @click="commit">提交</el-button>
        </el-col>
      </el-row>
      <!-- <el-button class="tpf-mf-layout--content--header--btn" type="text" icon="el-icon-view" @click="showForm">查看表单</el-button> -->
    </div>
    <tp-form-box class="tpf-mf-layout--content--form" :form-data="formData">
      <draggable
        v-model="formData.formDataList"
        class="tpf-mf-layout--content--draggable"
        group="TpFormGroup"
        animation="300"
      >
        <which-component v-for="li in formData.formDataList" :key="li.fieldId" :data="li" @click.native="clickComponent(li)" />
      </draggable>
    </tp-form-box>
    <el-dialog
      title="查看表单"
      :visible.sync="showFormVisible"
      width="600px"
    >
      <tp-form v-if="showFormVisible" :form-data="form" />
    </el-dialog>
    <el-dialog
      title="查看JSON"
      :visible.sync="showJSONVisible"
      width="600px"
    >
      <json-viewer v-if="showJSONVisible" :value="json" :expand-depth="2" />
    </el-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import TpFormBox from '../componentList/common/FormBox'
import WhichComponent from '../componentList/WhichComponent.vue'
export default {
  name: 'Content',
  components: { draggable, TpFormBox, WhichComponent },
  inject: ['commitFunc'],
  props: {
    formData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      showFormVisible: false,
      showJSONVisible: false,
      json: '{}',
      form: {},
      rules: {
        templateName: [{ required: true, message: '请填写巡检单名称', trigger: 'blur' }, { min: 3, max: 30, message: '长度在 5 到 30 个字符', trigger: 'blur' }]
      }
    }
  },
  watch: {
    'formData.formDataList': {
      handler(v) {
        this.$emit('change', v)
      },
      deep: true
    }
  },
  methods: {
    clickComponent(item) {
      this.formData.formDataList.forEach(f => {
        if (f.name === 'Layout') {
          f.setting.colList.forEach(c => {
            if (c) {
              console.log('abc:', c)
              c && (c.makeStyle.active = false)
            }
          })
        }
        if (f === item) f.makeStyle.active = true
        else f.makeStyle.active = false
      })
      this.$emit('select-change', item)
    },
    showForm() {
      this.form = this.$parent.$getFormDataByVueSet()
      this.showFormVisible = true
      // this.$store.state.formData = this.formData;
      // this.$router.push('/show')
    },
    showJSON() {
      this.json = this.$parent.$getFormDataByVueSet()
      this.showJSONVisible = true
    },
    commit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.commitFunc()
          // this.json = this.$parent.$getFormDataJSON()
        }
      })
    }
  }
}
</script>

<style scoped>
.content--header {
  width: 100%;
}
.text-right {
  text-align: right;
}
</style>
